import { makeStyles } from "@material-ui/core/styles";

export const addExpenseSelectionDialogCss = makeStyles(theme => ({
    divV1: {
        fontWeight: 300,
        letterSpacing: '1px',
    },
    closeButton: {
        fontSize: 18,
        color: '#e0e0e0',
    },
    dialogTitleV1: {
        paddingLeft: 22,
        paddingRight: 22,
        paddingTop: 12,
        paddingBottom: 12,
        "& .MuiTypography-root": {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    },
    dialogContentV1: {
        paddingLeft: 30,
        paddingRight: 30,
        paddingTop: 8,
        paddingBottom: 8,
    },
    gridItemFuel: {
        display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', paddingTop: 20, paddingBottom: 20, paddingLeft: 22, paddingRight: 22,
        "&:hover": {
            backgroundColor: "whitesmoke"
        }
    },
    gridItemMaintenance: {
        display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', paddingTop: 20, paddingBottom: 20, paddingLeft: 10, paddingRight: 10,
        "&:hover": {
            backgroundColor: "whitesmoke"
        }
    },
    gridItemDriver: {
        display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', cursor: 'pointer', paddingTop: 20, paddingBottom: 20, paddingLeft: 12, paddingRight: 12,
        "&:hover": {
            backgroundColor: "whitesmoke"
        }
    },
    paper1: {
        borderRadius: 8
    },
    fuelBookIcon: {
        fontSize: '3em', display: 'flex', alignSelf: 'flex-end'
    },
    maintenanceIcon: {
        fontSize: '3.2em', marginLeft: 8
    },
    driverIcon: {
        fontSize: '3.3em', marginLeft: 7
    },
}));

export const addExpenseDialogCss = makeStyles(theme => ({
    divV1: {
        fontWeight: 300,
        fontSize: 20
    },
    optionText: {
        color: '#888888',
        fontSize: 12,
        marginTop: 2
    },
    disableCta: {
        padding: '9px 26px 11px 28px',
        borderRadius: 4,
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
        backgroundColor: '#efeff2',
        fontSize: 14,
        fontWeight: 'bold',
        color: '#3e3f42',
        height: 36,
        textTransform: 'capitalize',
        letterSpacing: '0.02em'
    },
    saveCta: {
        padding: '9px 26px 11px 28px',
        borderRadius: 4,
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
        backgroundColor: '#09101e',
        fontSize: 14,
        fontWeight: 300,
        color: 'white',
        height: 36,
        textTransform: 'capitalize',
        letterSpacing: '0.02em',
        '&:hover': {
            backgroundColor: '#09101e',
        }
    },
    eventIcon: {
        color: 'grey'
    },
    closeButton: {
        fontSize: 18,
        color: '#e0e0e0',
    },
    paper1: {
        borderRadius: 6,
        minWidth: '878px !important'
    },
    paper2: {
        borderRadius: 6,
    },
    marginV1: {
        marginTop: 8
    },
    textFieldV1: {
        marginTop: 8,
        width: '48%'
    },
    title: {
        color: '#9ea0a5'
    },
    titleV1: {
        color: '#9ea0a5',
        marginTop: 24
    },
    dialogTitleV1: {
        paddingLeft: 22,
        paddingRight: 22,
        paddingTop: 12,
        paddingBottom: 12,
        "& .MuiTypography-root": {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    },
    listBoxAutoCompelete: {
        margin: 0,
        padding: 0
    },
    listBoxOption: {
        padding: 0,
        minHeight: 46,
        maxHeight: 46,
        borderBottom: '1px solid #eaedf3',
        "&:first-child": {
        },
        "&:last-child": {
        }
    },
    switchControl: {
        marginLeft: 16
    },
    switch: {
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#0033cc'
        },
        '& .MuiSwitch-colorSecondary.Mui-checked': {
            color: '#0033cc'
        }
    },
    da1: {
        paddingTop: 21,
        paddingBottom: 21,
        paddingRight: 24
    },
    cancelButton: {
        textTransform: 'capitalize', marginRight: '16px', fontWeight: 300, backgroundColor: '#f6f7f9', paddingLeft: '20px', paddingRight: 20, paddingTop: 9, paddingBottom: 11,
        letterSpacing: '1px',
        "&:hover": {
            backgroundColor: '#f6f7f9'
        }
    },
    confirmV1: {
        backgroundColor: 'black',
        color: 'white',
        textTransform: 'capitalize',
        fontWeight: 300,
        letterSpacing: '1px',
        paddingLeft: 36,
        paddingRight: 36,
        paddingTop: 9,
        paddingBottom: 11,
        "&:hover": {
            backgroundColor: 'black'
        }
    },
    divV2: {
        display: 'flex', justifyContent: 'space-betwaddExpenseDialogCsseen', marginTop: 16
    },
    wV1: {
        width: '50%'
    },
    divV3: {
        width: '50%', marginLeft: 30
    },
    divV4: {
        display: 'flex', marginTop: 20
    },
    divV5: {
        fontWeight: 300, fontSize: 16
    },
    marginV2: {
        marginTop: 16
    },
    marginV3: {
        marginTop: 28
    },
    radioV1: {
        color: "#0033cc !important"
    },
    radioV1Error: {
        color: 'red !important'
    },
    paymentTypeLabel: {
        marginBottom: 0
    },
    paymentTypeLabelError: {
        marginBottom: 0,
        color: 'red'
    },
    inputAdornmentV1: {
        height: '0 !important',
        alignItems: 'baseline'
    },
    textNote: {
        alignItems: 'start !important',
        "& .MuiInputBase-root": {
            alignItems: 'start !important'
        }
    },
    newExpenseTypeV1: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        backgroundColor: '#E8E8E8',
        paddingLeft: 10,
        paddingRight: 10
    },
    capitalize: {
        textTransform: 'capitalize'
    },
    newExpenseTypeV2: {
        display: 'flex',
        alignItems: 'center',
    },
    selectV1: {
        "& .MuiSelect-selectMenu": {
            paddingTop: 4,
            paddingBottom: 4,
            fontSize: 14
        }
    },
    customTextField: {
        marginTop: 8,
        "& .MuiFormHelperText-contained": {
            fontSize: 14,
            marginLeft: '0px !important'
        }
    },
    textTransformCaptialize: {
        textTransform: 'capitalize'
    },
    fontSize32: {
        fontSize: 32,
    },
    divV6: {
        marginLeft: 16, fontWeight: 300
    },
    divExpenseName: {
        display: 'flex', width: '100%', paddingTop: 5, paddingBottom: 5, paddingLeft: 16, fontWeight: 300
    },
    divMargin: {
        margin: 0, marginTop: 6
    },
    divV7: {
        display: 'flex', alignItems: 'end', marginTop: 16
    },
    divV8: {
        display: 'flex', alignItems: 'center'
    },
    divV9: {
        marginLeft: 4, marginRight: 4
    },
    paperWidth: {
        maxWidth: '460px !important'
    },
    divTripV2: {
        fontSize: 16,
        fontWeight: 300,
        marginTop: 6
    },
    mtV2: {
        marginTop: 16
    },
    shopOption: {
        paddingLeft: 0,
        paddingRight: 0,
        borderBottom: '1px solid #eaedf3',
        paddingTop: 0,
        paddingBottom: 0
    },
    shopListItem: {
        padding: '12px 15px',
        minHeight: 46,
        margin: 0,
        // maxHeight: 46,
        width: '100%',
        //borderBottom:"1px solid #eaedf3"
    },
    shopListItem1: {
        padding: '12px 15px',
        minHeight: 46,
        margin: 0,
        maxHeight: 46,
        width: '100%',
        color: "#5170f0",
        backgroundColor: '#E3E8FD'
    },
    billingTypeRadio: {
        maxWidth: '100% !important',
        marginTop: 16,
        '& .MuiFormControl-fullWidth': {
            //maxWidth:'100% !important'
        },
        '& .MuiFormControlLabel-root': {
            //marginRight:0
        },
        '& .MuiRadio-root': {
            //display:'none'
        },
        '& .MuiFormLabel-root': {
            fontSize: 12,
            letterSpacing: '0.05em',
            marginBottom: 12,
        }
    },
    billingTypeLabel: {
        //height: 36,
        //padding: '6px 12px',
        borderRadius: 16,
        marginRight: 6,
        marginLeft: 0,
        backgroundColor: '#e4e4e4',
        '& .MuiButtonBase-root': {
            display: 'none'
        },
        '& .MuiTypography-root': {
            fontSize: 14,
            padding: '8px 12px',
            borderRadius: 16,
            backgroundColor: '#e4e4e4',
            color: '#6b778c',
            fontWeight: 300,
        },
        '& span.Mui-checked+span': {
            color: '#0033cc',
            fontWeight: 300,
            backgroundColor: '#d1ddff',
            border: '1px solid #0033cc',
            paddingTop: 7,
            paddingBottom: 7,
            paddingLeft: 11,
            paddingRight: 11,
            fontSize: 14,
        }
    },
    titleBullet: {
        borderRadius: "50%",
        backgroundColor: "lightgrey",
        fontSize: 8,
        color: "lightgrey",
        margin: "0px 6px",
        marginTop: -2
    },
    addPersonIcon: {
        color: '#0033cc',
        marginRight: 10
    },
    listBoxV1: {
        paddingTop: '0px !important',
        paddingBottom: '0px !important'
    },
    autoCompletePaper: {
        marginBottom: '14px !important'
    },
    cherveRightIconV1: {
        marginLeft: 10,
        float: 'right',
        color: '#5170f0'
    },
}));

export const markDoneCss = makeStyles((theme) => ({
    paper2: {
        borderRadius: 6,
    },
    eventIcon: {
        color: 'grey'
    },
    dialogTitleV1: {
        paddingLeft: 22,
        paddingRight: 22,
        paddingTop: 12,
        paddingBottom: 12,
        "& .MuiTypography-root": {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    },
    divV1: {
        fontWeight: 300,
        fontSize: 20
    },
    closeButton: {
        fontSize: 18,
        color: '#e0e0e0',
    },
    marginV3: {
        marginTop: 28
    },
    da1: {
        paddingTop: 21,
        paddingBottom: 21,
        paddingRight: 24
    },
    cancelButton: {
        textTransform: 'capitalize', marginRight: '16px', fontWeight: 300, backgroundColor: '#f6f7f9', paddingLeft: '20px', paddingRight: 20, paddingTop: 9, paddingBottom: 11,
        letterSpacing: '1px',
        "&:hover": {
            backgroundColor: '#f6f7f9'
        }
    },
    confirmV1: {
        backgroundColor: 'black',
        color: 'white',
        textTransform: 'capitalize',
        fontWeight: 300,
        letterSpacing: '1px',
        paddingLeft: 36,
        paddingRight: 36,
        paddingTop: 9,
        paddingBottom: 11,
        "&:hover": {
            backgroundColor: 'black'
        }
    },
    marginV1: {
        marginTop: 6
    },
    marginV2: {
        marginTop: 16
    },
    title: {
        color: '#9ea0a5',
        fontSize: 12
    },
    divV4: {
        display: 'flex', marginTop: 20
    },
    divV5: {
        fontWeight: 300, fontSize: 16
    },
    switchControl: {
        marginLeft: 16
    },
    switch: {
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#0033cc'
        },
        '& .MuiSwitch-colorSecondary.Mui-checked': {
            color: '#0033cc'
        }
    },
    divV7: {
        display: 'flex', alignItems: 'end', marginTop: 16
    },
    divV8: {
        display: 'flex', alignItems: 'center'
    },
    divV9: {
        marginLeft: 4, marginRight: 4
    },
    selectV1: {
        "& .MuiSelect-selectMenu": {
            paddingTop: 4,
            paddingBottom: 4,
            fontSize: 14
        }
    },
    textNote: {
        alignItems: 'end !important',
        "& .MuiInputBase-root": {
            alignItems: 'end !important'
        }
    },
    inputAdornmentV1: {
        height: '0 !important',
        alignItems: 'baseline'
    },
    paperWidth: {
        maxWidth: '460px !important'
    },
    divBox: {
        width: '100%', marginTop: '16px', backgroundColor: '#f6f4f4', paddingTop: '10px', paddingBottom: '12px', paddingLeft: '16px'
    },
    color1: {
        color: '#6b778c'
    },
    divExpenseType: {
        fontWeight: 'bold', fontSize: 16
    }
}));

export const addDocumentDialogCss = makeStyles((theme) => ({
    paper2: {
        borderRadius: 6,
    },
    eventIcon: {
        color: 'grey'
    },
    dialogTitleV1: {
        paddingLeft: 22,
        paddingRight: 22,
        paddingTop: 12,
        paddingBottom: 12,
        "& .MuiTypography-root": {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    },
    divV1: {
        fontWeight: 300,
        fontSize: 20
    },
    closeButton: {
        fontSize: 18,
        color: '#e0e0e0',
    },
    paperWidth: {
        maxWidth: '460px !important'
    },
    divBox: {
        width: '100%', marginTop: '16px', backgroundColor: '#f6f4f4', paddingTop: '10px', paddingBottom: '12px', paddingLeft: '16px'
    },
    color1: {
        color: '#6b778c'
    },
    divData: {
        fontWeight: 'bold', fontSize: 16
    },
    marginV3: {
        marginTop: 28
    },
    da1: {
        paddingTop: 21,
        paddingBottom: 21,
        paddingRight: 24
    },
    cancelButton: {
        textTransform: 'capitalize', marginRight: '16px', fontWeight: 300, backgroundColor: '#f6f7f9', paddingLeft: '20px', paddingRight: 20, paddingTop: 9, paddingBottom: 11,
        letterSpacing: '1px',
        "&:hover": {
            backgroundColor: '#f6f7f9'
        }
    },
    confirmV1: {
        backgroundColor: 'black',
        color: 'white',
        textTransform: 'capitalize',
        fontWeight: 300,
        letterSpacing: '1px',
        paddingLeft: 36,
        paddingRight: 36,
        paddingTop: 9,
        paddingBottom: 11,
        "&:hover": {
            backgroundColor: 'black'
        }
    },
    vehicleNumber: {
        "&:last-child": {
            color: '#0033cc',
            marginLeft: 4,
        }
    },
    marginV1: {
        marginTop: 6
    },
    documentNumber: {
        marginTop: 6,
        "& .MuiOutlinedInput-input": {
            textTransform: 'uppercase'
        }
    },
    marginV2: {
        marginTop: 16
    },
    title: {
        color: '#9ea0a5',
        fontSize: 12
    },
    formHelperText: {
        color: '#9ea0a5',
        fontSize: 11,
        marginTop: 4,
    },
    divV8: {
        display: 'flex', alignItems: 'center', marginTop: 16
    },
    selectV1: {
        "& .MuiSelect-selectMenu": {
            paddingTop: 4,
            paddingBottom: 4,
            fontSize: 14
        },
        marginLeft: 4,
        marginRight: 4,
    },
    divV9: {
        marginLeft: 4, marginRight: 4
    },
    checkButton: {
        color: '#0033cc',
        fontWeight: 'bold',
        textTransform: 'capitalize',
        marginTop: 16,
        borderRadius: 8
    },
    bullet: {
        display: "inline-block",
        margin: "0 8px",
        transform: "scale(1.9)",
        color: "#c7c7c7"
    },
}));

export const addEmiCss = makeStyles((theme) => ({
    marginV2: {
        marginTop: 16
    },
    title: {
        color: '#9ea0a5',
        fontSize: 12
    },
    marginV1: {
        marginTop: 8
    },
    paper2: {
        borderRadius: 6,
    },
    paperWidth: {
        maxWidth: 460
    },
    dialogTitleV1: {
        paddingLeft: 22,
        paddingRight: 22,
        paddingTop: 12,
        paddingBottom: 12,
        "& .MuiTypography-root": {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    },
    divV1: {
        fontWeight: 300,
        fontSize: 20
    },
    closeButton: {
        fontSize: 18,
        color: '#e0e0e0',
    },
    marginV3: {
        marginTop: 28
    },
    da1: {
        paddingTop: 21,
        paddingBottom: 21,
        paddingRight: 24
    },
    cancelButton: {
        textTransform: 'capitalize', marginRight: '16px', fontWeight: 300, backgroundColor: '#f6f7f9', paddingLeft: '20px', paddingRight: 20, paddingTop: 9, paddingBottom: 11,
        letterSpacing: '1px',
        "&:hover": {
            backgroundColor: '#f6f7f9'
        }
    },
    confirmV1: {
        backgroundColor: 'black',
        color: 'white',
        textTransform: 'capitalize',
        fontWeight: 300,
        letterSpacing: '1px',
        paddingLeft: 36,
        paddingRight: 36,
        paddingTop: 9,
        paddingBottom: 11,
        "&:hover": {
            backgroundColor: 'black'
        }
    },
    divV7: {
        display: 'flex', alignItems: 'end', marginTop: 24, justifyContent: 'space-between'
    },
    divV8: {
        display: 'flex', alignItems: 'center'
    },
    selectV1: {
        width: '100% !important',
        marginTop: 8
    },
    selectV2: {
        "& .MuiSelect-selectMenu": {
            paddingTop: 4,
            paddingBottom: 4,
            fontSize: 14
        },
        marginLeft: 7,
        marginRight: 7
    },
    divSelect: {
        marginTop: 16,
        "& .MuiFormControl-root": {
            width: '100% !important'
        }
    },
    switchControl: {
        marginLeft: 16
    },
    switch: {
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#0033cc'
        },
        '& .MuiSwitch-colorSecondary.Mui-checked': {
            color: '#0033cc'
        }
    },
}));

export const addPastPaymentCss = makeStyles(() => ({
    divSelect: {
        marginTop: 16,
        "& .MuiFormControl-root": {
            width: '100% !important'
        }
    },
    eventIcon: {
        color: 'grey'
    },
    selectV1: {
        width: '100% !important',
        marginTop: 8
    },
    marginV2: {
        marginTop: 16
    },
    title: {
        color: '#9ea0a5',
        fontSize: 12
    },
    marginV1: {
        marginTop: 8
    },
    paper2: {
        borderRadius: 6,
    },
    paperWidth: {
        maxWidth: 460
    },
    dialogTitleV1: {
        paddingLeft: 22,
        paddingRight: 22,
        paddingTop: 12,
        paddingBottom: 12,
        "& .MuiTypography-root": {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    },
    divV1: {
        fontWeight: 300,
        fontSize: 20
    },
    closeButton: {
        fontSize: 18,
        color: '#e0e0e0',
    },
    marginV3: {
        marginTop: 28
    },
    da1: {
        paddingTop: 21,
        paddingBottom: 21,
        paddingRight: 24
    },
    cancelButton: {
        textTransform: 'capitalize', marginRight: '16px', fontWeight: 300, backgroundColor: '#f6f7f9', paddingLeft: '20px', paddingRight: 20, paddingTop: 9, paddingBottom: 11,
        letterSpacing: '1px',
        "&:hover": {
            backgroundColor: '#f6f7f9'
        }
    },
    confirmV1: {
        backgroundColor: 'black',
        color: 'white',
        textTransform: 'capitalize',
        fontWeight: 300,
        letterSpacing: '1px',
        paddingLeft: 36,
        paddingRight: 36,
        paddingTop: 9,
        paddingBottom: 11,
        "&:hover": {
            backgroundColor: 'black'
        }
    },
    menuItemV1: {
        display: 'none !important'
    }
}));

export const markPaidDialogCss = makeStyles((theme) => ({
    marginV2: {
        marginTop: 16
    },
    eventIcon: {
        color: 'grey'
    },
    title: {
        color: '#9ea0a5',
        fontSize: 12
    },
    marginV1: {
        marginTop: 8
    },
    dialogTitleV1: {
        paddingLeft: 22,
        paddingRight: 22,
        paddingTop: 12,
        paddingBottom: 12,
        "& .MuiTypography-root": {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    },
    divV1: {
        fontWeight: 300,
        fontSize: 20
    },
    closeButton: {
        fontSize: 18,
        color: '#e0e0e0',
    },
    paper2: {
        borderRadius: 6,
    },
    paperWidth: {
        maxWidth: 460
    },
    marginV3: {
        marginTop: 28
    },
    da1: {
        paddingTop: 21,
        paddingBottom: 21,
        paddingRight: 24
    },
    cancelButton: {
        textTransform: 'capitalize', marginRight: '16px', fontWeight: 300, backgroundColor: '#f6f7f9', paddingLeft: '20px', paddingRight: 20, paddingTop: 9, paddingBottom: 11,
        letterSpacing: '1px',
        "&:hover": {
            backgroundColor: '#f6f7f9'
        }
    },
    confirmV1: {
        backgroundColor: 'black',
        color: 'white',
        textTransform: 'capitalize',
        fontWeight: 300,
        letterSpacing: '1px',
        paddingLeft: 36,
        paddingRight: 36,
        paddingTop: 9,
        paddingBottom: 11,
        "&:hover": {
            backgroundColor: 'black'
        }
    },
}));
